import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import sanitizeHtml from "sanitize-html";
import { cleanCompanyName } from "utils/cleanCompanyName";
import NipWithCopy from "../NipWithCopy";

const BuyerCell: FC<Props> = ({ element }) => {
  return (
    <div className={styles.wrapper}>
      <div className={`${styles.stack}`}>
        <div
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(cleanCompanyName(element.Buyer?.Name)),
          }}
          className={styles.sender}
        ></div>
        {/* Drugi wiersz: NIP nabywcy (identyfikator; maska + kopiuj na hover). */}
        <NipWithCopy nip={element.Buyer?.Identifier?.Value} />
      </div>
    </div>
  );
};

export default BuyerCell;
